import React from 'react';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import FreelancerLineItemService from '../../../Services/FreelancerLineItemService';
import FreelancerLineItemSearchParams from './FreelancerLineItemSearchParams';
import FreelancerLineItem from '../../../Domain/FreelancerLineItem';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import FreelancerLineItemWindowDescription from './FreelancerLineItemWindowDescription';
import RepeatLineItemWindowDescription from './RepeatLineItemWindowDescription';
import RepeatLineItemData from './RepeatLineItemData';
import ErrorMessage from '../../../Elements/ErrorMessage';
import stringHelper from '../../../Helpers/stringHelper';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import UserService from '../../../Services/userService';
import AuthService from '../../../Services/authService';

class FreelancerLineItemAdmin extends React.Component {
  static defaultProps = {};

  constructor(props) {
    super(props);

    const searchItem = props.searchItem ? props.searchItem : new FreelancerLineItemSearchParams();
    if (props.freelancerInvoiceId) {
      searchItem.FreelancerInvoiceId = props.freelancerInvoiceId.toString();
      searchItem.OfficeId = '';
    }
    this.state = {
      itemList: [],
      selected: -1,
      selectedItem: null,
      orderBy: 'FreelancerLineItemId',
      orderDirection: OrderDirectionsEnum.Desc,
      pageNumber: 1,
      numberOfElementsInTheTable: 0,
      shownPanel:
        FreelancerLineItemSearchParams.isThereAnySearchParameter(searchItem) && this.props.showSearchPanel
          ? ShownPanelsEnum.Search
          : ShownPanelsEnum.None,
      searchItem: searchItem,
    };
    this.startSearch = this.startSearch.bind(this);
    FreelancerLineItem.editFunction = this.editFunction.bind(this);
    FreelancerLineItem.repeatLineItemFunction = this.repeatLineItemFunction.bind(this);
    this.clickOnLookingForTimeBasedLineItems = this.clickOnLookingForTimeBasedLineItems.bind(this);
    FreelancerLineItem.clickOnSelect = this.clickOnSelect.bind(this);
    this.clickOnRemoveFromInvoiceButton = this.clickOnRemoveFromInvoiceButton.bind(this);
    this.clickOnRemoveFromInvoiceButtonInPopup = this.clickOnRemoveFromInvoiceButtonInPopup.bind(this);
    FreelancerLineItem.clickOnGlobalSelect = this.selectAllElements.bind(this);
    FreelancerLineItem.selectedStatus = this.selectedStatus.bind(this);
  }

  removableStatus = 'OnDraftInvoice';

  clickOnSelect(item, selected) {
    item.Selected = selected;
    const templist = [...this.state.itemList];
    templist.forEach((element) => {
      if (element.FreelancerLineItemId === item.FreelancerLineItemId) {
        element.Selected = selected;
      }
    });
    this.setState({ itemList: templist });
  }

  refresh() {
    this.setState({ searchItem: { ...this.state.searchItem } });
  }

  editPanelOnClose(refresh) {
    this.setState({
      shownPanel: ShownPanelsEnum.None,
    });
    if (refresh) {
      this.refresh();
    }
  }

  clickOnLookingForTimeBasedLineItems() {
    FreelancerLineItemService.LookingForTimeBasedLineItems().catch(() => ErrorMessage.SetErrorMessage('FLIA175'));

    const message =
      'Timesheet based Line Item creation has been started. This process will run in the background. You will be notified about the result in your personal notification repository.';
    ErrorMessage.SetSuccess(message);
  }

  repeatLineItemFunction(item) {
    this.setState({
      shownPanel: ShownPanelsEnum.Repeat,
      selectedItem: item,
    });
  }

  editFunction(id, item, itemList) {
    this.setState({
      shownPanel: ShownPanelsEnum.EditItem,
      selectedItem: item,
    });
  }

  closePanel(refreshData) {
    this.setState({ shownPanel: ShownPanelsEnum.None });
    if (refreshData) {
      this.refresh();
    }
  }

  clickOnOkInEditPanel() {
    this.setState({ shownPanel: ShownPanelsEnum.None }, this.refresh());
  }

  showPanel(key) {
    if (key === this.state.shownPanel) key = ShownPanelsEnum.None;
    this.setState({ shownPanel: key });
  }

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              iconName: 'fa-regular fa-reply-clock',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Primary,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.clickOnLookingForTimeBasedLineItems(),
              tooltip: 'Collect Time-Based Line Items',
              roleKey: 'freelancerdatatable_action',
            },
            {
              iconName: 'fa-solid fa-link-slash',
              type: ButtonTypeEnum.NormalIconOnly,
              color: ButtonColorsEnum.Common,
              iconPosition: IconPositionEnum.Center,
              onClick: () => this.clickOnRemoveFromInvoiceButton(),
              tooltip: 'Remove from Invoice',
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  renderPanels() {
    switch (this.state.shownPanel) {
      case ShownPanelsEnum.EditItem:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={this.clickOnOkInEditPanel.bind(this)}
            windowDescription={FreelancerLineItemWindowDescription}
            errorCode='FLIA158'
          />
        );
      case ShownPanelsEnum.Repeat:
        return (
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={new RepeatLineItemData(this.state.selectedItem)}
            clickOnCancel={() => this.closePanel(false)}
            clickOnSave={() => this.closePanel(true)}
            windowDescription={RepeatLineItemWindowDescription}
            errorCode='LI-REPEAT'
          />
        );

      default:
        return null;
    }
  }

  clickOnRemoveFromInvoiceButton() {
    const numberOfLineItems = this.state.itemList.filter((i) => i.Selected && i.Status === this.removableStatus).length;
    const message = `You will remove ${stringHelper.plural(
      numberOfLineItems,
      'line item'
    )} from their invoice. (Only line items on draft invoice.)`;
    ErrorMessage.SetApprove(message, this.clickOnRemoveFromInvoiceButtonInPopup);
  }

  clickOnRemoveFromInvoiceButtonInPopup() {
    const selectedIds = this.state.itemList
      .filter((i) => i.Selected && i.Status === this.removableStatus)
      .map((f) => f.FreelancerLineItemId);

    FreelancerLineItemService.RemoveFreelancerPayableAssignmentsFromInvoice(
      selectedIds,
      this.state.allItemInTheSearchAreSelected,
      this.state.searchItem
    )
      .then((result) => {
        this.refresh();
        const message = (
          <span>
            {stringHelper.plural(result, 'line item', 'line items', true, true)} been removed from the invoice.
          </span>
        );
        ErrorMessage.SetSuccess(message);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('Error! ErrorCode: ALA304');
      });
  }

  selectAllElements() {
    const selectedStatus = this.state.itemList.some((item) => item.Selected === false);

    const templist = [...this.state.itemList];

    if (templist !== undefined && templist.length > 0) {
      templist.map((c) => (c.Selected = selectedStatus));
    }
    this.setState({ itemList: templist });
  }

  selectedStatus() {
    return !this.state.itemList.some((x) => x.Selected === false);
  }

  startSearch(searchItem) {
    if (
      AuthService.HasRoleArray(['FinanceAdmin_VendorMgtm', 'VendorInvoicingAdmin_*']) &&
      !AuthService.IsAdmin() &&
      !searchItem?.OfficeId
    ) {
      searchItem = { ...searchItem, OfficeId: UserService.GetOfficeIdOfLoggedInUser() };
    }
    this.setState({
      searchItem,
    });
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={FreelancerLineItem}
          shownPanel={this.state.shownPanel}
          serviceFunction={FreelancerLineItemService.GetFreelancerLineItemList}
          convertDBItemsFunction={FreelancerLineItemService.ConvertDBFreelancerLineItem}
          searchItem={this.state.searchItem}
          searchParamsType={FreelancerLineItemSearchParams}
          orderDirection={this.state.orderDirection}
          showSearchStrip={true}
          clickOnStartSearch={this.startSearch}
          itemList={this.state.itemList}
          changeOfItemListFunction={(itemList) => this.setState({ itemList })}
          errorCode='FLIA222'
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search for id, vendor, client, survey or invoice...'
        />
      </div>
    );
  }
}

export default FreelancerLineItemAdmin;
